/* eslint-disable indent */
/* eslint-disable quotes */
import React from 'react';
import { Modal, Button, Input } from 'antd';
import './style.scss';

const SyncToOda = ({ visible, onCancel, onSubmit, loading }) => {
    const [otpSent, setOtpSent] = React.useState(false);
    const [otpVerified, setOtpVerified] = React.useState(false);
    const [otpStatus, setOtpStatus] = React.useState('');
    const [isMobileVerified, setIsMobileVerified] = React.useState(false);

    const [formData, setFormData] = React.useState({
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        mobileNo: '',
        otp: ''
    });

    const handleSendOtp = (e) => {
        e.preventDefault();
        setOtpSent(true);
        setOtpStatus('sent');
    };

    const handleVerifyOtp = () => {
        const isOtpCorrect = false;
        if (isOtpCorrect) {
            setOtpVerified(true);
            setOtpStatus('verified');
            setIsMobileVerified(true);
        } else {
            setOtpStatus('incorrect');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const isEmailValid = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex
        return emailRegex.test(email);
    };

    const isMobileNoValid = (mobileNo) => {
        return /^\d{10}$/.test(mobileNo); // Check for exactly 10 digits
    };

    const isFormFilled = () => {
        return Object.values(formData).every(field => field.trim() !== '') && 
               isEmailValid(formData.email) && 
               isMobileNoValid(formData.mobileNo) && 
               isMobileVerified;
    };

    return (
        <Modal
            title="Verify DA Mobile No."
            open={visible}
            onCancel={onCancel}
            centered={true}
            maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.45)' }}
            style={{ top: '50%', fontFamily: 'Roboto', width: '750px' }}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    CANCEL
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={onSubmit}
                    disabled={!isFormFilled()}
                >
                    SYNC TO ODA
                </Button>,
            ]}
        >
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '48%' }}>
                        <label className="label-style">First Name <span style={{ color: 'red' }}>*</span></label>
                        <Input
                            name="firstName"
                            className="input-field-style"
                            style={{ marginTop: '5px' }}
                            onChange={handleInputChange}
                            autoComplete='off'
                        />
                    </div>
                    <div style={{ width: '48%' }}>
                        <label className="label-style">Last Name <span style={{ color: 'red' }}>*</span></label>
                        <Input
                            name="lastName"
                            className="input-field-style"
                            style={{ marginTop: '5px' }}
                            onChange={handleInputChange}
                            autoComplete='off'
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <div style={{ width: '48%' }}>
                        <label className="label-style">Email <span style={{ color: 'red' }}>*</span></label>
                        <Input
                            name="email"
                            className="input-field-style"
                            style={{ marginTop: '5px' }}
                            onChange={handleInputChange}
                            autoComplete='off'
                        />
                    </div>
                    <div style={{ width: '48%' }}>
                        <label className="label-style">Username <span style={{ color: 'red' }}>*</span></label>
                        <Input
                            name="username"
                            className="input-field-style"
                            style={{ marginTop: '5px' }}
                            onChange={handleInputChange}
                            autoComplete='off'
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <div style={{ width: '48%' }}>
                        <label className="label-style">Mobile No <span style={{ color: 'red' }}>*</span></label>
                        <Input
                            name="mobileNo"
                            className="input-field-style"
                            style={{ marginTop: '5px' }}
                            onChange={handleInputChange}
                            type="number"
                            autoComplete='off'
                        />
                    </div>
                    <div style={{ width: '48%' }}>
                        <label className="label-style">Verify OTP <span style={{ color: 'red' }}>*</span></label>
                        <Input
                            name="otp"
                            className="input-field-style"
                            style={{ marginTop: '5px' }}
                            onChange={handleInputChange}
                            autoComplete='off'
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    <a href="#" onClick={handleSendOtp} style={{ color: isMobileNoValid(formData.mobileNo) ? (otpStatus === 'sent' ? 'green' : 'blue') : 'lightgray' }}>
                        {otpSent ? 'OTP Sent' : 'Send OTP'}
                    </a>
                    {otpSent && (
                        <a href="#" onClick={handleVerifyOtp} style={{ color: otpStatus === 'verified' ? 'green' : otpStatus === 'incorrect' ? 'red' : 'blue' }}>
                            {otpVerified ? 'OTP Verified' : otpStatus === 'incorrect' ? 'Incorrect OTP' : 'Verify OTP'}
                        </a>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default SyncToOda;
